import { render, staticRenderFns } from "./TopFour.vue?vue&type=template&id=d45aad3c&scoped=true&"
import script from "./TopFour.vue?vue&type=script&lang=js&"
export * from "./TopFour.vue?vue&type=script&lang=js&"
import style0 from "./TopFour.vue?vue&type=style&index=0&id=d45aad3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45aad3c",
  null
  
)

export default component.exports